import { ReactNode } from 'react';
import { Navbar } from '@/shared/components/layout/Navbar';
import { LoadingSpinner } from '@/shared/components/ui/loading-spinner';

interface OnboardingLayoutProps {
  children?: ReactNode;
  isLoading?: boolean;
}

export const OnboardingLayout = ({ children, isLoading }: OnboardingLayoutProps) => {

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-primary/10 flex items-center justify-center p-4">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-primary/5 via-background to-primary/10">
      <Navbar onMenuClick={() => {}} isOnboarding={true} />
      <div className="flex-1 flex items-start justify-center p-4 pt-24 pb-4 overflow-y-auto">
        {children}
      </div>
    </div>
  );
};
